// Active season configuration
export const ACTIVE_SEASON = 5;
